/* eslint-disable no-unused-vars */
import { doc, getDoc, setDoc, updateDoc, arrayUnion, arrayRemove } from 'firebase/firestore';
import { db } from '../firebase';

export const favoritesService = {
  async getFavoriteVendors(userId) {
    try {
      const favoritesRef = doc(db, 'eoFavorites', userId);
      const docSnap = await getDoc(favoritesRef);
      
      if (docSnap.exists()) {
        return {
          success: true,
          favorites: docSnap.data().vendors || []
        };
      }
      return { success: true, favorites: [] };
    } catch (error) {
      console.error('Error fetching favorites:', error);
      return { success: false, error: error.message, favorites: [] };
    }
  },

  async addFavorite(userId, vendor) {
    try {
      const favoritesRef = doc(db, 'eoFavorites', userId);
      const docSnap = await getDoc(favoritesRef);
      
      // Build favorite data, filtering out undefined values (Firestore doesn't accept undefined)
      const favoriteData = {
        mpsId: vendor.mpsId || vendor.id || '',
        businessName: vendor.businessName || vendor.company || 'Unknown',
        businessType: vendor.businessType || 'Not specified',
        email: vendor.email || vendor.businessEmail || '',
        phone: vendor.phone || vendor.businessPhoneNumber || '',
        companyLogo: vendor.companyLogo || vendor.image || '',
        addedAt: new Date().toISOString()
      };

      // Remove any remaining undefined/null values
      Object.keys(favoriteData).forEach(key => {
        if (favoriteData[key] === undefined || favoriteData[key] === null) {
          favoriteData[key] = '';
        }
      });

      if (docSnap.exists()) {
        // Get current vendors and check for duplicates
        const currentVendors = docSnap.data().vendors || [];
        const alreadyExists = currentVendors.some(v => v.mpsId === favoriteData.mpsId);
        
        if (!alreadyExists) {
          await setDoc(favoritesRef, {
            ...docSnap.data(),
            vendors: [...currentVendors, favoriteData]
          });
        }
      } else {
        await setDoc(favoritesRef, {
          vendors: [favoriteData],
          createdAt: new Date().toISOString()
        });
      }
      
      return { success: true };
    } catch (error) {
      console.error('Error adding favorite:', error);
      return { success: false, error: error.message };
    }
  },

  async removeFavorite(userId, mpsId) {
    try {
      const favoritesRef = doc(db, 'eoFavorites', userId);
      const docSnap = await getDoc(favoritesRef);
      
      if (docSnap.exists()) {
        const currentVendors = docSnap.data().vendors || [];
        const updatedVendors = currentVendors.filter(v => v.mpsId !== mpsId);
        
        await setDoc(favoritesRef, {
          ...docSnap.data(),
          vendors: updatedVendors
        });
      }
      
      return { success: true };
    } catch (error) {
      console.error('Error removing favorite:', error);
      return { success: false, error: error.message };
    }
  },

  async isFavorite(userId, mpsId) {
    try {
      const result = await this.getFavoriteVendors(userId);
      if (result.success) {
        return result.favorites.some(v => v.mpsId === mpsId);
      }
      return false;
    } catch (error) {
      return false;
    }
  }
};
